import { LocalizedDatePipe } from './../home/localized.pipe';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SafePipe } from './safe.pipe';

@NgModule({
  declarations: [
    SafePipe,
    LocalizedDatePipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    SafePipe,
    LocalizedDatePipe
  ]
})
export class SharedModule { }
